import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
@Entity('assign_rejections_log')
export class AssignRejections {

  @PrimaryGeneratedColumn("increment", { name: 'assign_rejection_id' })
  assignRejectionId: number;

  @Column("int", {
    nullable: false,
    name: "rejected_quantity"
  })
  rejectedQuantity: number;

  @Column("int", {
    nullable: false,
    name: "assigned_quantity"
  })
  assignedQuantity: number;

  @Column("varchar", {
    nullable: false,
    length: 40,
    name: "lot_number"
  })
  lotNumber: string;

  @Column("int",{
    nullable:false,
    name:"count"
    })
    Count:number;
  @Column("int",{
    nullable:false,
    name:"sale_order_id"
    })
    saleOrderId:number;
  @Column("int",{
    nullable:false,
    name:"sale_order_item_id"
    })
    saleOrderItemId:number;
    @Column({
        type: 'enum',
        enum: OperationTypeEnum,
        nullable: true,
        name: 'operation'
    })
    operation: OperationTypeEnum;
    @Column("datetime", {
        nullable: true,
        name: "assigned_time",
    })
    assignedTime: Date
  @Column("int", {
    nullable: true,
    name: "unit_id"
  })
  unitId: number;

  @Column("int", {
    nullable: true,
    name: "prod_inv_id"
})
prodInvId: number;
 
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;
  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
 
}